import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

import { Input } from 'antd';
import type { InputRef } from 'antd';

import { useFormik } from 'formik';
import { tap } from 'rxjs/operators';
import Modal from 'v2/components/Shared/Modal';
import { transferHistoryService } from 'v2/services/transferHistory';
import * as Yup from 'yup';

interface ICompositionModalProps {
  open: boolean;
  setClose: () => void;
  compositionId: number;
}

interface IFormModel {
  email: string;
}

function CompositionModal({ open, setClose, compositionId }: ICompositionModalProps) {
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  const mailForm = useFormik<IFormModel>({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('O e-mail informado não é um e-mail válido!').required('E-mail obrigatório!')
    }),
    onSubmit: values => {
      transferHistoryService
        .setCompositionRequest(compositionId, values.email)
        .pipe(
          tap(
            () => {
              toast.success(`Relatório será enviado para o email: ${values.email}`);
            },
            err => {
              toast.error(err);
            }
          )
        )
        .subscribe();
      handleCloseModal();
    }
  });

  const handleCloseModal = () => {
    mailForm.setValues({ email: '' });
    setClose();
  };

  const emailError = mailForm.touched.email && mailForm.errors.email ? mailForm.errors.email : '';

  return (
    <Modal
      keepMounted
      open={open}
      setClose={handleCloseModal}
      textTitle='Composição de saque'
      textReturnButton='Cancelar'
      textProceedButton='Enviar'
      handleProceedClick={mailForm.handleSubmit}
      isProceedButtonDisabled={!mailForm.isValid}
    >
      <p className='mb-4'>Informe o e-mail para envio do relatório.</p>

      <Input
        id='email'
        name='email'
        placeholder='E-mail'
        ref={inputRef}
        value={mailForm.values.email}
        onChange={mailForm.handleChange}
        onBlur={mailForm.handleBlur}
        status={emailError ? 'error' : undefined}
      />
      {emailError && <div className='mt-1 text-xs text-red-500'>{emailError}</div>}
    </Modal>
  );
}

export default CompositionModal;
